// «Editar» loads the message into the conversation's OWN composer — the full box, its formatting,
// emoji and `@` strips — with an «Editando mensaje» bar above it; Enter saves, Esc / ✕ cancels.
// User order 2026-10-22 («When I edit a message I do not get a full compose window»). Same rule on
// the five clients (shared/API.md §42); twin of ios/Sources/ViewModels/ComposerEdit.swift.
//
// What the box held before the edit is put aside and given back when the edit ends, saved or not.

export interface ComposerEdit {
  postId: string;
  /** The message as it was when editing began — saving it unchanged sends nothing. */
  original: string;
  /** The draft the box held before; restored on save and on cancel. */
  stashedDraft: string;
}

export type ComposerEditOutcome = { kind: 'keepEditing' } | { kind: 'close' } | { kind: 'save'; text: string };

export const ComposerEdit = {
  /** Re-targeting while already editing keeps the FIRST stash (the box holds the other message). */
  begin(current: ComposerEdit | null, composeText: string, postId: string, message: string): ComposerEdit {
    return { postId, original: message, stashedDraft: current ? current.stashedDraft : composeText };
  },

  outcome(edit: ComposerEdit, text: string): ComposerEditOutcome {
    const trimmed = text.trim();
    if (!trimmed) return { kind: 'keepEditing' };
    if (trimmed === edit.original.trim()) return { kind: 'close' };
    return { kind: 'save', text: trimmed };
  },
};
